<template>
    <div>
        <nav class="navbar navbar-default">
            <div class="container-fluid container">
                <div class="navbar-header">
                    <button id="ddown1" type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1" aria-expanded="false">
                        <span class="sr-only">Toggle navigation</span>
                        <span class="icon-bar"></span>
                        <span class="icon-bar"></span>
                        <span class="icon-bar"></span>
                      </button>
                    <router-link class="navbar-brand" to="/" tag="a" active-class="active" exact><a><span class="glyphicon glyphicon-home" aria-hidden="true"></span></a></router-link>
                </div>
                <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
                    <ul class="nav navbar-nav">
                        <router-link to="/offers" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1" tag="li" active-class="active" v-if="loggedIn"><a>Offers</a></router-link>
                    </ul>
                    <ul class="nav navbar-nav">
                        <router-link to="/setup" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1" tag="li" active-class="active" v-if="loggedIn"><a>Setup</a></router-link>
                    </ul>
                    <ul class="nav navbar-nav navbar-right">
                        <li v-if="loggedIn" @click="logOut()"><a href="">Sign Out</a></li>
    
                    </ul>
                </div>
            </div>
        </nav>
    </div>
</template>

<script>
    import firebase from 'firebase'
    import db from '@/components/db'
    import userData from '@/components/uid'
    import { eventBus } from '@/main'
    let user = userData.data();
    
    export default {
        data() {
            return {
                data: 'Start',
                user: {},
                email: '',
                loggedIn: ''
            }
        },
        methods: {
            logOut: function() {
                firebase.auth().signOut().then(function() {
                    // Sign-out successful.
                }).catch(function(error) {
                    // An error happened.
                });
            },
            collapseMenu: function() {
                
            }
        },
        created() {
            eventBus.$on('loggedIn', (data) => {
                this.loggedIn = data;
            })
        }
    }
</script>

<style scoped>
    .navbar {
        background-color: #f0f0f0;
        min-height: 43px;
    }
</style>


// WEBPACK FOOTER //
// Header.vue?bc577600